'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var makeStyles = require('../../Styles/makeStyles.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var Tooltip = require('../../DataDisplay/Tooltips/Tooltip.js');
var IconButton = require('../../Inputs/Buttons/IconButton.js');
var CloseMenu = require('../../../IconsAndImages/Icons/CloseMenu.js');
var OpenMenu = require('../../../IconsAndImages/Icons/OpenMenu.js');
var LeftNavigationUsingList = require('./LeftNavigationUsingList.js');
var Drawer = require('../../../node_modules/@material-ui/core/esm/Drawer/Drawer.js');
var Box = require('../../../node_modules/@material-ui/core/esm/Box/Box.js');
var Toolbar = require('../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');
var Slide = require('../../../node_modules/@material-ui/core/esm/Slide/Slide.js');
var Tabs = require('../../../node_modules/@material-ui/core/esm/Tabs/Tabs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DRAWER_WIDTH_OPEN = 260;
var DRAWER_WIDTH_CLOSED = 57;
var useStyles = makeStyles["default"](function (theme) {
  return {
    pageTitle: {
      flexGrow: 1,
      marginTop: theme.spacing(3),
      fontSize: 24,
      color: theme.palette.grey[900]
    },
    expandButton: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(1)
    },
    drawer: {
      width: function width(_ref) {
        var _width = _ref.width;
        return _width || DRAWER_WIDTH_OPEN;
      },
      flexShrink: 0,
      whiteSpace: 'nowrap'
    },
    drawerOpen: {
      overflowX: 'hidden',
      width: function width(_ref2) {
        var _width2 = _ref2.width;
        return _width2 || DRAWER_WIDTH_OPEN;
      },
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerClose: {
      width: DRAWER_WIDTH_CLOSED,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    belowMainNav: {
      zIndex: theme.zIndex.appBar - 1
    },
    tabIndicator: {
      left: theme.spacing(3),
      marginTop: theme.spacing(1.5),
      maxHeight: theme.spacing(2)
    },
    toolBarGutters: {
      paddingRight: 0
    },
    drawerHeader: {
      backgroundColor: theme.palette.background.paper,
      position: "sticky",
      top: 0,
      zIndex: 1
    },
    drawerContent: {
      height: 'max(100vh, 100%)',
      overflow: function overflow(_ref3) {
        var collapsed = _ref3.collapsed;
        return collapsed ? 'hidden' : 'auto';
      }
    },
    drawerFooter: {
      padding: theme.spacing(2, 3)
    }
  };
});
var LeftNavigationDrawerContent = React__default["default"].forwardRef(function (_ref4, ref) {
  var _classNames;

  var _ref4$open = _ref4.open,
      open = _ref4$open === void 0 ? true : _ref4$open,
      onClose = _ref4.onClose,
      onOpen = _ref4.onOpen,
      width = _ref4.width,
      title = _ref4.title,
      actions = _ref4.actions,
      tabValue = _ref4.tabValue,
      onTabChange = _ref4.onTabChange,
      appearsBelowMainNav = _ref4.appearsBelowMainNav,
      className = _ref4.className,
      classes = _ref4.classes,
      footer = _ref4.footer,
      TabsProps = _ref4.TabsProps,
      ToolbarProps = _ref4.ToolbarProps,
      SlideProps = _ref4.SlideProps,
      children = _ref4.children,
      props = objectWithoutProperties(_ref4, ["open", "onClose", "onOpen", "width", "title", "actions", "tabValue", "onTabChange", "appearsBelowMainNav", "className", "classes", "footer", "TabsProps", "ToolbarProps", "SlideProps", "children"]);

  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      isUsingList = _useLeftNavigationCon.isUsingList;

  var _React$useState = React__default["default"].useState(!open),
      _React$useState2 = slicedToArray(_React$useState, 2),
      collapsed = _React$useState2[0],
      setCollapsed = _React$useState2[1];

  var _useStyles = useStyles({
    width: width,
    collapsed: collapsed
  }),
      pageTitle = _useStyles.pageTitle,
      expandButton = _useStyles.expandButton,
      drawer = _useStyles.drawer,
      drawerOpen = _useStyles.drawerOpen,
      drawerClose = _useStyles.drawerClose,
      belowMainNav = _useStyles.belowMainNav,
      tabIndicator = _useStyles.tabIndicator,
      toolBarGutters = _useStyles.toolBarGutters,
      drawerHeader = _useStyles.drawerHeader,
      drawerContent = _useStyles.drawerContent,
      drawerFooter = _useStyles.drawerFooter;

  return React__default["default"].createElement(Drawer["default"], _objectSpread({
    anchor: "left",
    variant: "permanent",
    className: classNames__default["default"](drawer, className),
    classes: _objectSpread({}, classes, {
      paper: classNames__default["default"]((_classNames = {}, defineProperty(_classNames, drawerOpen, open), defineProperty(_classNames, drawerClose, !open), defineProperty(_classNames, belowMainNav, appearsBelowMainNav), _classNames), classes === null || classes === void 0 ? void 0 : classes.paper)
    })
  }, props, {
    ref: ref
  }), React__default["default"].createElement(Box["default"], {
    display: "flex",
    flexDirection: "column",
    className: drawerContent
  }, React__default["default"].createElement(Box["default"], {
    className: drawerHeader
  }, appearsBelowMainNav && React__default["default"].createElement(Toolbar["default"], null), collapsed && React__default["default"].createElement(Tooltip, {
    title: "Expand"
  }, React__default["default"].createElement(IconButton, {
    onClick: onOpen,
    className: expandButton
  }, React__default["default"].createElement(OpenMenu, null))), React__default["default"].createElement(Slide["default"], _objectSpread({
    direction: "right",
    "in": open,
    onEntering: function onEntering() {
      return setCollapsed(false);
    },
    onExited: function onExited() {
      return setCollapsed(true);
    }
  }, SlideProps), React__default["default"].createElement(Toolbar["default"], _objectSpread({}, ToolbarProps, {
    classes: _objectSpread({
      gutters: toolBarGutters
    }, ToolbarProps === null || ToolbarProps === void 0 ? void 0 : ToolbarProps.classes)
  }), React__default["default"].createElement(Typography, {
    component: "div",
    variant: "h2",
    className: pageTitle
  }, title), actions, React__default["default"].createElement(Tooltip, {
    title: "Collapse"
  }, React__default["default"].createElement(IconButton, {
    onClick: onClose
  }, React__default["default"].createElement(CloseMenu, null)))))), React__default["default"].createElement(Box["default"], {
    flex: 1
  }, React__default["default"].createElement(React__default["default"].Fragment, null, isUsingList ? React__default["default"].createElement(LeftNavigationUsingList, {
    tabValue: tabValue,
    onTabChange: onTabChange,
    onSlideOpen: open
  }, children) : React__default["default"].createElement(Slide["default"], _objectSpread({
    direction: "right",
    "in": open
  }, SlideProps), React__default["default"].createElement(Tabs["default"], _objectSpread({
    orientation: "vertical",
    variant: "scrollable",
    scrollButtons: "off",
    value: tabValue,
    onChange: onTabChange,
    classes: {
      indicator: tabIndicator
    }
  }, TabsProps), children)))), footer && React__default["default"].createElement(Box["default"], null, React__default["default"].createElement(Slide["default"], _objectSpread({
    direction: "right",
    "in": open
  }, SlideProps), React__default["default"].createElement("div", {
    className: drawerFooter
  }, footer)))));
});

var LeftNavigation = function LeftNavigation(_ref5) {
  var tabValue = _ref5.tabValue,
      _ref5$isUsingList = _ref5.isUsingList,
      isUsingList = _ref5$isUsingList === void 0 ? false : _ref5$isUsingList,
      props = objectWithoutProperties(_ref5, ["tabValue", "isUsingList"]);

  return React__default["default"].createElement(LeftNavigationContext.LeftNavigationProvider, {
    tabValue: tabValue,
    isUsingList: isUsingList
  }, React__default["default"].createElement(LeftNavigationDrawerContent, _objectSpread({
    tabValue: tabValue
  }, props)));
};

exports.DRAWER_WIDTH_CLOSED = DRAWER_WIDTH_CLOSED;
exports.DRAWER_WIDTH_OPEN = DRAWER_WIDTH_OPEN;
exports["default"] = LeftNavigation;
